module.exports = __webpack_public_path__ + "static/media/plus.94676a13.svg";